import React from 'react';
import { useChat } from '../../contexts/ChatContext';
import AnimatedElement from '../animations/AnimatedElement';

function Prompts() {
  const prompts = [
    "What is SchoolLine?",
    "What are the main features?",
    "Tell me about the Diary feature",
    "Tell me about the pricing",
  ];

  const { sendMessage} = useChat();

  return (
    <>
      {prompts.map((prompt, index) => (
        <AnimatedElement
          key={index}
          delay={index * 0.3} // Apply staggered animation delay
          animationClass="animate-slide-fade-in" // Use desired animation class
        >
          <div
            className="bg-gray-800 text-gray-200 p-4 rounded-3xl shadow-lg 
                       hover:bg-gray-700 transition-all cursor-pointer"
            onClick={() => sendMessage(prompt)} // Trigger sendMessage on click
          >
            {prompt}
          </div>
        </AnimatedElement>
      ))}
    </>
  );
}

export default Prompts;